import './create-shortcut-mac-popup.html';
import CreateShortcutMacPopup from './create-shortcut-mac-popup.js';

export default CreateShortcutMacPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/create-shortcut-mac-popup/index.js